
export const root = {
    background: '{dropdown.background}',
    borderColor: '{dropdown.border.color}',
    color: '{dropdown.color}',
    borderRadius: '{dropdown.border.radius}',
    shadow: '{dropdown.shadow}',
    transitionDuration: '{transition.duration}',
    padding: '{dropdown.padding}',
    minWidth: '{dropdown.min.width}'
};

export const list = {
    padding: '{navigation.list.padding}',
    gap: '{navigation.list.gap}'
};

export const item = {
    focusBackground: '{dropdown.item.focus.background}',
    activeBackground: '{dropdown.item.focus.background}',
    color: '{dropdown.item.color}',
    focusColor: '{dropdown.item.focus.color}',
    activeColor: '{dropdown.item.focus.color}',
    padding: '{dropdown.item.padding}',
    borderRadius: '{dropdown.item.border.radius}',
    gap: '{dropdown.item.gap}',
    hoverBackground: '{dropdown.item.hover.background}',
    icon: {
        color: '{dropdown.item.icon.color}',
        focusColor: '{dropdown.item.icon.focus.color}',
        activeColor: '{dropdown.item.icon.focus.color}'
    }
};

export const submenu = {
    mobileIndent: '1.25rem'
};

export const submenuIcon = {
    size: '{navigation.submenu.icon.size}',
    color: '{dropdown.submenu.icon.color}',
    focusColor: '{dropdown.submenu.icon.focus.color}',
    activeColor: '{dropdown.submenu.icon.focus.color}'
};

export const separator = {
    borderColor: '{dropdown.separator.border.color}'
};

export const colorScheme = {
    dark: {
        item: {
            hoverColor: '{dropdown.item.hover.color}',
            icon: {
                hoverColor: '{dropdown.item.icon.hover.color}'
            }
        }
        // root styling now inherited from {dropdown.*} tokens in base theme
    }
};

// Root: transparent bg — frosted glass via backdrop-filter in styles.scss.
// Submenu: opaque — can't use backdrop-filter inside a parent that already has it (CSS stacking context).
export const css = ({dt}: {dt: (token: string) => string}) => `
.p-tieredmenu {
    font-size: 0.875rem;
    background: transparent;
}
.p-tieredmenu-submenu {
    background: ${dt('surface.overlay')};
    border: 1px solid ${dt('surface.border')};
    border-radius: ${dt('tieredmenu.border.radius')};
    box-shadow: ${dt('tieredmenu.shadow')};
}
`;

export default {
    root,
    list,
    item,
    submenu,
    submenuIcon,
    separator,
    colorScheme,
    css
};
